	export enum TenantCountry {
		US = 1,
		GB = 2,
		CA = 3,
		AU = 4
	}
